<!--
  Иконка температуры: термометр.
  Обычно используется в блоках температурных требований и режимов перевозки.
-->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M15 14.76V5C15 3.34315 13.6569 2 12 2C10.3431 2 9 3.34315 9 5V14.76C7.77893 15.6722 7 17.1291 7 18.75C7 21.5114 9.23858 23.75 12 23.75C14.7614 23.75 17 21.5114 17 18.75C17 17.1291 16.2211 15.6722 15 14.76Z"
      :stroke="stroke"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M12 6V18"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: "TemperatureIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
